/**
 * projectIdentity.js — what makes one saved project distinct from another.
 *
 * Every project carries a `project_id`, assigned when it enters the app (see
 * projectStore.projectSelected). Auto-save stores the project under that id, so
 * two projects with the same name never share a slot, and renaming a project
 * saves over its own entry. The displayed name (`project_info.name`) is only a
 * label; `freeProjectName` keeps new names distinct so the Recent list reads well.
 */

import ipc from './ipc';

export function newProjectId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  return `p-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

// `base`, or `base 2`, `base 3`… — the first name not in `takenNames`.
export function firstFreeName(base, takenNames) {
  const taken = new Set(takenNames);
  let name = base;
  for (let n = 2; taken.has(name); n++) name = `${base} ${n}`;
  return name;
}

// The first name no saved project uses (see firstFreeName).
export async function freeProjectName(base) {
  let list = [];
  try { list = await ipc.invoke('list-saved-projects'); } catch (_) { /* assume none */ }
  return firstFreeName(base, (Array.isArray(list) ? list : []).map((p) => p?.name).filter(Boolean));
}
